import React, { PureComponent, Fragment } from "react";
import { Dropdown, Input, Typography, Modal, Skeleton, Tooltip } from "antd";
import { connect } from "react-redux";
import { routeLogin, api } from "../../config/api";
import { authCheckService, authService } from "../../redux/services";
import { authActions } from "../../redux/actions";

import styles from "./index.css";

const { Search } = Input;

class CompanyName extends PureComponent {
  state = { isTruncated: false };

  checkTruncated = (event) => {
    const { scrollWidth, clientWidth } = event.currentTarget;
    this.setState({ isTruncated: scrollWidth > clientWidth });
  };

  render() {
    const { name } = this.props;

    return (
      <Tooltip title={this.state.isTruncated ? name : null} placement="left">
        <span className="byp-company-dropdown__name" onMouseEnter={this.checkTruncated}>
          {name}
        </span>
      </Tooltip>
    );
  }
}

class CompanyDropdown extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isSending: false,
      companies: [],
      loading: true,
      hasMultipleCompanies: false,
      isOpen: false,
    };
  }

  componentDidMount() {
    this.searchCompany("");
  }

  handleSubmit = ({ key: cliente_id }) => {
    if (!cliente_id) return;

    this.setState({
      isSending: true,
    });

    authService
      .changeLogin(cliente_id)
      .then((response) => {
        if (response.data === 0) return;
        const { user } = this.props;

        // TODO Thiago - Verificar
        const values = {
          action: "updateAuth",
          cliente_id,
          email: user.email,
          token: api.defaults.headers.common["Authorization"],
        };

        routeLogin(
          values,
          (success) => {
            this.setState({
              isSending: false,
            });
            // Do Login
            this.props.doLogin(success);
            window.location.reload(true);
          },
          (error) => {
            this.setState({
              isSending: false,
            });

            Modal.error({
              title: "Ocorreu um erro!",
              content: String(error),
            });
          }
        );
      })
      .catch((data) => {
        console.log("error", data);
      });
  };

  searchCompany = (search) => {
    const { user } = this.props;
    this.setState({ loading: true }, () => {
      authCheckService
        .checkClientes({ email: user.email, search })
        .then((response) => {
          const { data: companies } = response;
          // Only the unfiltered result tells whether the user has more than one database
          const newState = { companies, loading: false };
          if (!search) newState.hasMultipleCompanies = companies?.length > 1;
          this.setState(newState);
        });
    });
  };

  render() {
    const { visible = true } = this.props;
    const companyCurrent = JSON.parse(localStorage.getItem("@mainCompany"));
    const { companies, isSending, loading, hasMultipleCompanies, isOpen } = this.state;

    if (!visible || !companyCurrent) return <Fragment></Fragment>;

    return (
      <Dropdown
        disabled={!hasMultipleCompanies}
        loading={loading}
        menu={{
          items: companies?.map((company) => ({
            ...company,
            label: <CompanyName name={company.label} />,
          })),
          onClick: this.handleSubmit,
        }}
        trigger={["click"]}
        onOpenChange={(open) => this.setState({ isOpen: open })}
        className={styles.menu}
        overlayClassName="byp-company-dropdown"
        dropdownRender={(menu) => (
          <div className="byp-company-dropdown__panel">
            <div className="byp-company-dropdown__search">
              <Search allowClear onSearch={this.searchCompany} enterButton />
            </div>
            <div className="byp-company-dropdown__list">
              {menu}
            </div>
          </div>
        )}
      >
        {isSending ? (
          <Skeleton active paragraph={false} />
        ) : (
          <a
            className={`ant-dropdown-link${hasMultipleCompanies ? "" : " byp-company-dropdown__trigger--single"}`}
            href="#"
            style={{ marginRight: 10 }}
          >
            <Typography.Text type="secondary">Banco de Dados: </Typography.Text>
            <Typography.Text strong>{companyCurrent?.nome}</Typography.Text>
            {hasMultipleCompanies && (
              <i className={`fa fa-arrow-down byp-company-dropdown__arrow${isOpen ? " byp-company-dropdown__arrow--open" : ""}`}></i>
            )}
          </a>
        )}
      </Dropdown>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.auth.userData,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    doLogin: (data) => {
      dispatch(authActions.login(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyDropdown);
